import styled from 'styled-components';

// Styled components
export const StyledForm = styled.div`
  .ant-form-item {
    margin-bottom: 18px;
  }

  .ant-form-item-label > label {
    font-weight: 500;
    color: #4a4a4a;
  }

  .ant-select-selector {
    min-height: 40px;
  }

  .ant-input {
    height: 40px;
  }

  .ant-picker {
    border-radius: ${({ theme }) => theme.appearance.border_radius};
  }
`;

export const CompleteProfileModalContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
`;

export const CompleteProfileModalActions = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  justify-content: center;
`;
